// Comprehensive list of nationalities (FR + EN). Used by the participant
// nationality autocomplete. Kept in sync index-by-index between both locales.
export const NATIONALITIES_FR = [
  "Afghane", "Albanaise", "Algérienne", "Allemande", "Américaine", "Andorrane",
  "Angolaise", "Antiguaise", "Argentine", "Arménienne", "Australienne",
  "Autrichienne", "Azerbaïdjanaise", "Bahaméenne", "Bahreïnienne", "Bangladaise",
  "Barbadienne", "Béninoise", "Biélorusse", "Birmane", "Bissau-Guinéenne",
  "Bolivienne", "Bosnienne", "Botswanaise", "Brésilienne", "Britannique",
  "Brunéienne", "Bulgare", "Burkinabée", "Burundaise", "Cambodgienne",
  "Camerounaise", "Canadienne", "Cap-Verdienne", "Centrafricaine", "Chilienne",
  "Chinoise", "Chypriote", "Colombienne", "Comorienne", "Congolaise (Brazzaville)",
  "Congolaise (RDC)", "Costaricienne", "Croate", "Cubaine", "Danoise",
  "Djiboutienne", "Dominicaine", "Dominiquaise", "Égyptienne", "Émirienne",
  "Équatorienne", "Érythréenne", "Espagnole", "Estonienne", "Eswatinienne",
  "Éthiopienne", "Fidjienne", "Finlandaise", "Française", "Gabonaise",
  "Gambienne", "Géorgienne", "Ghanéenne", "Grecque", "Grenadienne",
  "Guatémaltèque", "Guinéenne", "Équato-guinéenne", "Guyanienne", "Haïtienne",
  "Hondurienne", "Hongroise", "Indienne", "Indonésienne", "Irakienne",
  "Iranienne", "Irlandaise", "Islandaise", "Israélienne", "Italienne",
  "Ivoirienne", "Jamaïcaine", "Japonaise", "Jordanienne", "Kazakhe",
  "Kényane", "Kirghize", "Kiribatienne", "Koweïtienne", "Laotienne",
  "Lésothane", "Lettone", "Libanaise", "Libérienne", "Libyenne",
  "Liechtensteinoise", "Lituanienne", "Luxembourgeoise", "Macédonienne",
  "Malaisienne", "Malawite", "Maldivienne", "Malgache", "Malienne",
  "Maltaise", "Marocaine", "Marshallaise", "Mauricienne", "Mauritanienne",
  "Mexicaine", "Micronésienne", "Moldave", "Monégasque", "Mongole",
  "Monténégrine", "Mozambicaine", "Namibienne", "Nauruane", "Néerlandaise",
  "Néo-Zélandaise", "Népalaise", "Nicaraguayenne", "Nigériane", "Nigérienne",
  "Nord-Coréenne", "Norvégienne", "Omanaise", "Ougandaise", "Ouzbèke",
  "Pakistanaise", "Palaosienne", "Palestinienne", "Panaméenne", "Papouane-Néo-Guinéenne",
  "Paraguayenne", "Péruvienne", "Philippine", "Polonaise", "Portugaise",
  "Qatarienne", "Roumaine", "Russe", "Rwandaise", "Saint-Lucienne",
  "Saint-Marinaise", "Saint-Vincentaise", "Salomonaise", "Salvadorienne", "Samoane",
  "São-Toméenne", "Saoudienne", "Sénégalaise", "Serbe", "Seychelloise",
  "Sierra-Léonaise", "Singapourienne", "Slovaque", "Slovène", "Somalienne",
  "Soudanaise", "Sud-Africaine", "Sud-Coréenne", "Sud-Soudanaise", "Sri-Lankaise",
  "Suédoise", "Suisse", "Surinamaise", "Syrienne", "Tadjike",
  "Taïwanaise", "Tanzanienne", "Tchadienne", "Tchèque", "Thaïlandaise",
  "Timoraise", "Togolaise", "Tongienne", "Trinidadienne", "Tunisienne",
  "Turkmène", "Turque", "Tuvaluane", "Ukrainienne", "Uruguayenne",
  "Vanuatuane", "Vaticane", "Vénézuélienne", "Vietnamienne", "Yéménite",
  "Zambienne", "Zimbabwéenne"
];

export const NATIONALITIES_EN = [
  "Afghan", "Albanian", "Algerian", "German", "American", "Andorran",
  "Angolan", "Antiguan", "Argentine", "Armenian", "Australian",
  "Austrian", "Azerbaijani", "Bahamian", "Bahraini", "Bangladeshi",
  "Barbadian", "Beninese", "Belarusian", "Burmese", "Bissau-Guinean",
  "Bolivian", "Bosnian", "Botswanan", "Brazilian", "British",
  "Bruneian", "Bulgarian", "Burkinabé", "Burundian", "Cambodian",
  "Cameroonian", "Canadian", "Cape Verdean", "Central African", "Chilean",
  "Chinese", "Cypriot", "Colombian", "Comorian", "Congolese (Brazzaville)",
  "Congolese (DRC)", "Costa Rican", "Croatian", "Cuban", "Danish",
  "Djiboutian", "Dominican", "Dominica (Dominican)", "Egyptian", "Emirati",
  "Ecuadorian", "Eritrean", "Spanish", "Estonian", "Eswatini",
  "Ethiopian", "Fijian", "Finnish", "French", "Gabonese",
  "Gambian", "Georgian", "Ghanaian", "Greek", "Grenadian",
  "Guatemalan", "Guinean", "Equatorial Guinean", "Guyanese", "Haitian",
  "Honduran", "Hungarian", "Indian", "Indonesian", "Iraqi",
  "Iranian", "Irish", "Icelandic", "Israeli", "Italian",
  "Ivorian", "Jamaican", "Japanese", "Jordanian", "Kazakh",
  "Kenyan", "Kyrgyz", "I-Kiribati", "Kuwaiti", "Lao",
  "Lesotho", "Latvian", "Lebanese", "Liberian", "Libyan",
  "Liechtensteiner", "Lithuanian", "Luxembourger", "Macedonian",
  "Malaysian", "Malawian", "Maldivian", "Malagasy", "Malian",
  "Maltese", "Moroccan", "Marshallese", "Mauritian", "Mauritanian",
  "Mexican", "Micronesian", "Moldovan", "Monégasque", "Mongolian",
  "Montenegrin", "Mozambican", "Namibian", "Nauruan", "Dutch",
  "New Zealander", "Nepalese", "Nicaraguan", "Nigerian", "Nigerien",
  "North Korean", "Norwegian", "Omani", "Ugandan", "Uzbek",
  "Pakistani", "Palauan", "Palestinian", "Panamanian", "Papua New Guinean",
  "Paraguayan", "Peruvian", "Philippine", "Polish", "Portuguese",
  "Qatari", "Romanian", "Russian", "Rwandan", "Saint Lucian",
  "Sammarinese", "Saint Vincentian", "Solomon Islander", "Salvadoran", "Samoan",
  "São Toméan", "Saudi", "Senegalese", "Serbian", "Seychellois",
  "Sierra Leonean", "Singaporean", "Slovak", "Slovenian", "Somali",
  "Sudanese", "South African", "South Korean", "South Sudanese", "Sri Lankan",
  "Swedish", "Swiss", "Surinamese", "Syrian", "Tajik",
  "Taiwanese", "Tanzanian", "Chadian", "Czech", "Thai",
  "Timorese", "Togolese", "Tongan", "Trinidadian", "Tunisian",
  "Turkmen", "Turkish", "Tuvaluan", "Ukrainian", "Uruguayan",
  "Ni-Vanuatu", "Vatican", "Venezuelan", "Vietnamese", "Yemeni",
  "Zambian", "Zimbabwean"
];

const normalize = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export function searchNationalities(query, lang = "fr", limit = 8) {
  const list = lang === "en" ? NATIONALITIES_EN : NATIONALITIES_FR;
  const q = normalize(query.trim());
  if (!q) return [];
  const starts = [];
  const contains = [];
  for (const n of list) {
    const ln = normalize(n);
    if (ln.startsWith(q)) starts.push(n);
    else if (ln.includes(q)) contains.push(n);
    if (starts.length >= limit) break;
  }
  return [...starts, ...contains].slice(0, limit);
}
